<template>
  <div class="keuzemenu">
    <!-- <h3>Keuze opties</h3> -->
    <table>
      <tbody class="bodyclass">
        <tr
          v-for="(prize, i) in prizes"
          :key="i"
          class="k-entry"
        >
          <button
            @click="trashButtonHandler(i)"
            class="trash-button"
          >
            <vue-mdi
              icon="delete"
              color="white"
              size="mdi-24px"
            />
            <span class="tooltiptextbuttons">verwijderen</span>
          </button>
          <input
            id="text-box"
            v-model="prize.value"
            @input="prize.name = prize.value"
            placeholder="Voeg een keuzeoptie toe"
            autocomplete="off"
          />
        </tr>
      </tbody>
      <tfoot class="add-class">
        <button
          @click="addButtonHandler()"
          class="add-button"
        >
          <vue-mdi
            icon="plus"
            color="white"
            :size="1.3"
          />
        </button>
        <button
          @click="resetButtonHandler()"
          class="reset-button"
        >
          <vue-mdi
            icon="reload"
            color="white"
            :size="1.3"
          />
        </button>
      </tfoot>
    </table>
  </div>
</template>


<script>
  import { Vue, Component, Prop } from "vue-property-decorator";
  import darkorlight from "darkorlight";
  // import fileDialog from "vue-file64";

  @Component({
    components: {
      // fileDialog,
    }
  })
  class Keuzemenu extends Vue {
    @Prop({ type: Array, required: true }) prizes;
    @Prop({ required: true }) spinner;

    addButtonHandler() {
      // console.log("geklikt op add button!");
      let bgColor = "#" + Math.floor(Math.random() * 0xffffff).toString(16);
      let color = darkorlight.dark(bgColor) ? "#ffffff" : "#000000";

      this.prizes.push({
        bgColor,
        color,
        contentType: "text",
        id: Math.ceil(Math.random() * 1000000),
        name: "",
        value: "",
        weight: 1
      });
      // console.log(this.prizes);

      // focus & select nu nog zien te krijgen op de toegevoegde inputveld
      this.$nextTick(() => {
        /**
         *  @type {HTMLInputElement[]}
         * */
        let inputFields = document.querySelectorAll(".k-entry input");
        let input = inputFields[inputFields.length - 1];
        input.focus();
      });
    }

    resetButtonHandler() {
      localStorage.removeItem("app_prizes");
      location.reload();
    }

    /**
     * @param {number} index
     */
    trashButtonHandler(index) {
      // console.log("geklikt op de trash button!");
      this.prizes.splice(index, 1);
    }
  }

  export default Keuzemenu;
</script>

<style lang="scss" scoped>
table {
  background-color: #104b8c;
  min-width: 100%;
  min-height: 100%;
  padding: min(10%, 42px);
  border-radius: 4%;
  border: 3px solid white;

  .k-entry {
    display: flex;
    align-items: center;
  }
}

input {
  height: 20px;
  font-size: 20px;
  background: none;
  color: white;
  outline: none;
  border: hidden;
}

.add-class {
  text-align: center;
  // height: 15px;
}

.add-button {
  border: hidden;
  background: none;

  &:hover {
    transform: scale(1.1);
  }
}

.reset-button {
  border: hidden;
  background: none;

  &:hover {
    transform: scale(1.1);
  }
}

.bodyclass {
  display: grid;
  width: 100%;
  gap: 0.3em;
}

div div .keuzemenu {
  width: 415px;
  margin: 40px 10px;
}

.trash-button {
  background: none;
  border: hidden;
  margin-right: 10px;

  &:hover {
    transform: scale(1.1);
  }
  &:hover .tooltiptextbuttons {
    visibility: visible;
  }

  .tooltiptextbuttons {
    font-family: Roboto, sans-serif;
    visibility: hidden;
    width: 150px;
    background-color: #EA5503;
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 5px 0;
    margin-left: 9px;
    font-size: 10px;

    /* Position the tooltip */
    position: absolute;
    z-index: 1;
  }
}
</style>
